import { Reducer } from 'redux';

import { ActionTypes } from '../types/action-types';
import { ActionObject, IDIConfig } from '../types/config';

export default ((state = {
  enabled: false,
  criteria: {
  },
}, action: ActionObject): IDIConfig => {
  switch (action.type) {
    case ActionTypes.CONFIG_LOADED:
      return {
        ...action.config,
      };
  }
  return {...state};
}) as Reducer<IDIConfig>;



// WEBPACK FOOTER //
// ./src/sub-projects/datafiniti/reducers/config.ts